import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import WorkspacesIcon from '@mui/icons-material/Workspaces';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CancelIcon from '@mui/icons-material/Cancel';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons'; // or another appropriate package
import { faVolleyball } from '@fortawesome/free-solid-svg-icons';
import { IconButton, Tooltip, TableCell, Modal, Box } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import PrintIcon from '@mui/icons-material/Print';
import ReactDOM from 'react-dom';
import BillPrint from "./bill";

function CustomerIndex() {
  const [data, setData] = useState([]);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, companyId, userId, logout, token } = useAuth();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAuthenticated && tokenIsExpired(token)) {
      logout();
      return;
    }

    // const fetchtableData = async () => {


    // };

    fetchtableData();
    setLoading(true);
  }, [isAuthenticated, companyId, userId, token, logout]);


  useEffect(() => {
    fetchtableData();

  }, []);

  const fetchtableData = async () => {
    fetchData('CustomerApi', `/${companyId}`, token)
      .then((response) => {
        if (response.responseCode == '1111') {
          console.log(response);
          setData(response.response_data);
        }
      })
      .catch((error) => {
        console.error('Error fetching Customer Details:', error);
      })
      .finally(() => {
        setLoading(false); // Hide loading screen
      });
  };

  const handleDelete = async () => {
    deleteData('CustomerApi', `${deleteItemId}`, token)
      .then((response) => {
        fetchtableData();
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
      })
      .catch((error) => {
        console.error('Error deleting record:', error);
      });
  };

  const handleActivate = (itemId) => {
    activateData('CustomerApi', `${itemId}`, token)
      .then((response) => {
        fetchtableData();
      })
      .catch((error) => {
      });
  };

  const openConfirmDialog = (itemId) => {
    setDeleteItemId(itemId);
    setConfirmDialogOpen(true);
  };

  const closeConfirmDialog = () => {
    setDeleteItemId(null);
    setConfirmDialogOpen(false);
  };

  const [searchQuery, setSearchQuery] = useState('');
  const [showSearchInput, setShowSearchInput] = useState(false);
  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
  };

  const toggleSearchInput = () => {
    setShowSearchInput(!showSearchInput);
  };

  const filteredData = data.filter((item) =>
    Object.values(item).some((value) =>
      String(value).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  function formatDate(dateString) {
    if (!dateString) {
      return '';
    }

    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  function isExpired(dateString) {
    const currentDate = new Date();
    const date = new Date(dateString);
    return date < currentDate;
  }

  const handlePrint = async (saleid) => {
    try {

      const response = await fetchData('CustomerApi', `/CautionPrint/${saleid}`, token);
      const labelData = response.response_data;
      const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      document.body.appendChild(iframe);

      const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
      iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

      ReactDOM.render(
        <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
        iframeDocument.body
      );

      iframeDocument.write('</body></html>');
      iframeDocument.close();
      // iframe.contentWindow.print();
      setTimeout(() => {
        iframe.contentWindow.print();
      }, 1000);

    } catch (error) {
      console.error('Error printing Invoice:', error);
    }
  };

  return (
    <div className="w-full max-w-sm container mt-6 mx-auto" style={{ maxWidth: '95%' }}>
      <div className='w-full mb-2 flex'>
        <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>CUSTOMER</h6>
        {loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9999
          }}>
            <div>
              <CircularProgress style={{ color: 'white' }} />
              <span style={{ color: 'white', marginTop: '10px', display: 'block' }}>Loading...</span>
            </div>
          </div>
        )}
        <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
          <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
          {showSearchInput && (
            <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
              type="text"
              placeholder="Search..."
              value={searchQuery}
              onChange={handleSearch}
              style={{ marginLeft: '10px', width: '200px' }}
            />
          )}
        </div>
        <Tooltip title="Create New Customer">

          <Button
            variant="contained"
            startIcon={<AddIcon />}
            style={{
              marginRight: '8px',
              background: 'linear-gradient(to right, darkslategray, slategray)',
              borderRadius: '50px',
              padding: '10px 20px',
              color: 'white',
              fontWeight: 'bolder',
              textTransform: 'none',
              boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
              maxHeight: '35px',

            }}
            component={Link}
            to="/CustomerCreate"
          >
            Create
          </Button>

        </Tooltip>
      </div>

      <div className='w-full mb-5 flex' style={{ maxHeight: '500px', overflowY: 'auto' }}>
        <TableContainer component={Paper}>
          <Table stickyHeader>
            <TableHead sx={{ backgroundColor: '#0B5345' }}>
              <TableRow>
                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Sl.No</TableCell>
                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Name</TableCell>
                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Contact No</TableCell>
                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Address</TableCell>
                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Room</TableCell>
                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Rent Date</TableCell>
                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Leaving Date</TableCell>
                <TableCell sx={{ backgroundColor: '#0B5345', borderBottom: '1px solid #ddd', fontWeight: 'bolder', fontSize: '12px', padding: '3px', color: 'white', textTransform: 'uppercase' }}>Actions</TableCell>
              </TableRow>
            </TableHead>
            {/* <TableBody sx={{ backgroundColor: '#D5F5E3' }}> */}
            <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
              {filteredData.map((item, index) => (
                <TableRow key={item.Id}>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>{index + 1}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>{item.name}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>{item.contactNumber1} , {item.contactNumber2} </TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>{item.addressLine1}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>{item.roomName}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>{formatDate(item.rentDate)}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '2px', textAlign: 'left', fontSize: '12px' }}>{formatDate(item.DateOfLeaving)}</TableCell>
                  <TableCell sx={{ borderBottom: '1px solid #000000', color: 'black', fontWeight: 'bolder', padding: '5px', textAlign: 'left', fontSize: '12px' }}>
                    <Link to={`/CustomerEdit/${item.id}`}>
                      <Tooltip title="Edit Customer">
                        <IconButton>
                          <EditIcon style={{ color: 'red' }} />
                        </IconButton>
                      </Tooltip>
                    </Link>

                    <Tooltip title="Delete Customer">
                      <IconButton onClick={() => openConfirmDialog(item.id)}>
                        <DeleteIcon style={{ color: 'brown' }} />
                      </IconButton>
                    </Tooltip>
                    <IconButton onClick={() => handlePrint(item.id)}>
                      <PrintIcon style={{ color: 'teal' }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
            <Dialog
              open={confirmDialogOpen}
              onClose={closeConfirmDialog}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Are you sure you want to delete this record?
                </DialogContentText>
              </DialogContent>

              <DialogActions>
                <button
                  onClick={closeConfirmDialog}
                  style={{
                    backgroundColor: '#dc3545',
                    color: '#ffffff',
                    border: '1px solid #dc3545',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                    marginRight: '8px',
                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleDelete}
                  style={{
                    backgroundColor: '#28a745',
                    color: '#ffffff',
                    border: '1px solid #28a745',
                    borderRadius: '4px',
                    padding: '8px 16px',
                    cursor: 'pointer',
                  }}
                >
                  Confirm
                </button>
              </DialogActions>

            </Dialog>
          </Table>
        </TableContainer>
      </div >
    </div >
  );
}

export default CustomerIndex;

